import { render, staticRenderFns } from "./create-directory.vue?vue&type=template&id=15950e73&scoped=true"
import script from "./create-directory.vue?vue&type=script&lang=js"
export * from "./create-directory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15950e73",
  null
  
)

export default component.exports